<template>
  <div class="app has-header">
    <div class="header main">
      <div class="align-left">
        <dateselectionheader
            :label="dateSelectionStart.format('MMMM') + ' ' + dateSelectionStart.format('YYYY')"
            @PrevDate="setDateSelection(dateSelectionStart.add(-1, 'month'), true)"
            @NextDate="setDateSelection(dateSelectionStart.add(1, 'month'), true)"
            @CalendarOpen="OpenDateSelection"
            @SetToday="setDateSelection($helpers.getCurrentMonthMomentTZ(), true)"/>
      </div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons"/>
      </div>
      <div class="align-right"></div>
    </div>
    <div class="scrollbar-container">
      <datatable :state="dataTableState"/>
    </div>
    <div v-if="loading" class="loading-md bg">
      <i class="fas fa-spinner"></i>
    </div>
    <bannerconfirmation ref="bannerconfirmation"/>

  </div>

</template>

<script>
import {mapState, mapGetters} from 'vuex';
import VueEventBus from '../../../vue-event-bus';
import bannerconfirmation from './StoreBannerConfirmationPopup';

export default {
  name: 'storebannernotificationoverview',
  components: {
    bannerconfirmation
  },
  data() {
    return {
      storebannernotifications: [],
      selectedStoreBannerNotifications: [],
      storeBannerNotificationMap: {},
      storeBannerNotificationId: null,
      currentrow: {},
      storeBannerNotification: {
        description: "",
        from: null,
        to: null,
        level: 1,
        state: 1,
        confirmable: false,
        active: true,
        text: "",
      },
      dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ(),
      loading: true,

    }
  },
  created: function () {
    this.setDateSelection(this.$helpers.getCurrentMonthMomentTZ(), true);
    this.refresh();
  },
  computed: {
    ...mapGetters([
      'rosterFromTo', 'spotMap', 'uiDataMap', 'employeeMap', 'anonMode', 'uiDataMap'
    ]),
    countryMap() {
      let map = {};
      this.uiDataMap.countries.forEach(item => map[item.id] = item);
      return map;
    },
    dataTableState() {
      let view = this;
      let state = {};
      let month = this.rosterFromTo.month;
      let year = this.rosterFromTo.year;
      let bannernotifications = Object.values(this.storeBannerNotificationMap).filter(item => {
        let from = view.$helpers.getMomentFromStringTZ(item.from);
        //return from.month() == month && from.year() == year;
        return true;
      });
      state = this.$helpers.GetDataTableStateFromKeyLabelObject({
        description: this.$t('roster.main.title'),
        from: this.$t('global.general.from'),
        to: this.$t('global.general.to'),
        employeeLevels: this.$tc('global.general.employee'),
        spotId: this.$tc('shift.main.position'),
        nationality: this.$t('pages.employeeContext.nationality'),
        level: this.$t('pages.comp.importance'),
        state: this.$t('pages.comp.frontpage'),
        confirmable: this.$t('pages.comp.confirmable'),
        active: this.$t('global.general.active'),
        text: this.$t('pages.comp.text'),
      }, bannernotifications);

      Object.values(state.headerMap).forEach(e => e.align = 'center');

      state.headerMap['description'].sort = false;
      state.headerMap['description'].align = 'center';
      state.headerMap['description'].DisplayLabel = (i) => {
        return view.anonMode ? 'Anonymous Description' : i.description
      };
      state.headerMap['description'].width = '150px';


      state.headerMap['from'].sort = true;
      state.headerMap['from'].label = this.$t('global.general.from')
      state.headerMap['from'].DisplayLabel = (i) => {
        if(i.from != null){
          return view.$helpers.getMomentFromStringTZ(i.from).format('DD.MM.YYYY HH:mm');
        } else {
          return "-";
        }
      };
      state.headerMap['from'].align = 'center';


      state.headerMap['to'].sort = true;
      state.headerMap['to'].label = this.$t('global.general.to');
      state.headerMap['to'].DisplayLabel = (i) => {
        if(i.to != null){
          return view.$helpers.getMomentFromStringTZ(i.to).format('DD.MM.YYYY HH:mm');
        } else {
          return "-";
        }
        
      };
      state.headerMap['to'].align = 'center';

      state.headerMap['employeeLevels'].sort = false;
      state.headerMap['employeeLevels'].label = this.$tc('global.general.employee');
      state.headerMap['employeeLevels'].DisplayLabel = (i) => {
        if(i.selectedEmployeesOnly) {
          return 'Nur Ausgewählte'
        } else {
          if(i.employeeLevels != null){
            return view.employeeLevels.filter(l => i.employeeLevels.includes(l.value)).map(l => l.label).toString()
          } else {
            return "-";
          }
        }
        
        
      };
      state.headerMap['employeeLevels'].align = 'center';

      state.headerMap['spotId'].sort = false;
      state.headerMap['spotId'].label = this.$tc('shift.main.position');
      state.headerMap['spotId'].DisplayLabel = (i) => {
        if(i.selectedEmployeesOnly) {
          return '-'
        } else {
          if(i.spotId != null){
            return view.spotMap[i.spotId].name;
          } else {
            return this.$t('global.ui.all');
          }
        }
        
      };
      state.headerMap['spotId'].align = 'center';

      state.headerMap['nationality'].sort = false;
      state.headerMap['nationality'].label = this.$t('pages.employeeContext.nationality');
      state.headerMap['nationality'].DisplayLabel = (i) => {
        if(i.selectedEmployeesOnly) {
          return '-'
        } else {
          if(i.nationality != null){
            return view.countryMap[i.nationality].label_de;
          } else {
            return this.$t('global.ui.all');
          }
        }
        
      };
      state.headerMap['nationality'].align = 'center';


      state.headerMap['level'].sort = true;
      state.headerMap['level'].align = 'center';
      state.headerMap['level'].DisplayLabel = (i) => {
        let level = '';
        switch (i.level) {
          case 1:
            level = this.$t('pages.comp.veryImportant');
            break;
          case 2:
            level = this.$t('pages.comp.important');
            break;
          case 3:
            level = this.$t('pages.comp.information');
            break;
        }
        return level
      };


      state.headerMap.state.componentTypeRow = 'checkbox';
      state.headerMap.state.componentStateBuilder = (storeBannerNotification) => {
        return {
          propContainer: {value: storeBannerNotification.state === 1, data: storeBannerNotification},
          customEvents: {
            Update: ($event, value, storeBannerNotification) => {
              storeBannerNotification.state = value === true ? 1 : 2;
              view.UpdateStoreBannerNotification(storeBannerNotification);
            }
          }
        };
      };
      state.headerMap.confirmable.componentTypeRow = 'checkbox';
      state.headerMap.confirmable.componentStateBuilder = (storeBannerNotification) => {
        return {
          propContainer: {value: storeBannerNotification.confirmable, data: storeBannerNotification},
          customEvents: {
            Update: ($event, value, storeBannerNotification) => {
              storeBannerNotification.confirmable = value;
              view.UpdateStoreBannerNotification(storeBannerNotification);
            }
          }
        };
      };
      state.headerMap.active.componentTypeRow = 'checkbox';
      state.headerMap.active.componentStateBuilder = (storeBannerNotification) => {
        return {
          propContainer: {value: storeBannerNotification.active, data: storeBannerNotification},
          customEvents: {
            Update: ($event, value, storeBannerNotification) => {
              storeBannerNotification.active = value;
              view.UpdateStoreBannerNotification(storeBannerNotification);
            }
          }
        };
      };

      state.headerMap['text'].align = 'center';
      state.headerMap['text'].DisplayLabel = (i) => {
        return  view.anonMode ? 'Anonymous Text' : (i.text && i.text.length > 100 ? i.text.substring(0, 100)+'...' : i.text);
      };
      state.headerMap['text'].width = '25%';

      state.headerMap['actions'] = {
        buttons: [
          {
            icon: 'fas fa-eye', action: ($event, data) => view.ShowStoreBannerConfirmations(data), Show: (data) => {
              return data.confirmable === true && !view.anonMode
            }
          },
          {icon: 'fas fa-pencil-alt', action: ($event, data) => view.EditStoreBannerNotification(data), Show: (data) => {
              return !view.anonMode
          }},
          {icon: 'fas fa-trash', action: ($event, data) => view.DeleteBannerNotificationPopup(data), Show: (data) => {
              return !view.anonMode
          }},
        ]
      };
      state.headerMap['actions'].width = '120px';

      return state;
    },
    headerButtons() {
      let view = this;
      let state = {
        buttons: [
          {
            classes: "",
            type: "block",
            icon: "fa-refresh",
            click: () => {
              view.refresh()
            },
            tooltip: this.$t('global.ui.refresh'),
          },
          {
            classes: "",
            type: "block green",
            label: '',
            icon: "fa-plus",
            click: () => {
              view.NewStoreBannerNotificationPopup()
            },
            tooltip: this.$t('global.ui.createX', [this.$t('pages.comp.appInformation')]),
            helperText: this.$t('pages.comp.createAppInformationHelp'),
            externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2522710018"
          },

        ]
      };
      state.helperLinks = [
        {
          title:  this.$t('store.structure.getSupport'),
          helperText:  this.$t('store.structure.getSupportHelp'),
          externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/16",
          externalLabel:  this.$t('store.structure.getSupportLabel'),
          cancelLabel: this.$t('global.ui.close')
        }
      ];
      return state;
    },
    formattedTimeMap() {
      let map = {}
      for (let i = 0; i < this.storebannernotifications.length; i++) {
        let event = this.storebannernotifications[i];
        map[event.id] = {
          from: this.$helpers.getMomentFromString(event.from).format("DD.MM.YYYY HH:mm"),
          to: this.$helpers.getMomentFromString(event.to).format("DD.MM.YYYY HH:mm")
        }
      }
      return map;
    },
    storeId() {
      return this.$store.state.storeId;
    },
    employeeLevels() {
        let types = [];
        this.uiDataMap.employeeLevels.forEach(item => types.push({label: item.label_de, value: item.id}));
        return types;
    },
  },
  watch: {
    rosterFromTo(newVal, oldVal) {
      if (newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined && newVal.month != oldVal.month) {
        this.refresh();
      }
    },
    storeId(newVal, oldVal) {
      console.log("Changed storeId: " + newVal);
      this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function () {
      let view = this;
      this.selectedStoreBannerNotifications = [];
      this.loading = true;
      view.$helpers.GetUiDataMap()
      .then(response => {
        return view.$helpers.GetSpotMap();
      }).then(response => {
        return view.loadStoreBannerNotifications()
      }).then(response => {
        view.updateStoreBannerNotifications(response.data)
        view.loading = false;
      }).catch(function (error) {
        console.log(error)
      });

    },
    loadStoreBannerNotifications: function () {
      let view = this;
      let url = '/api/sec/bannernotification';
      let params = {
        storeId: this.$store.state.storeId,
        from: this.$helpers.getMomentTZ().month(this.$store.state.rosterFromTo.month).startOf('month').format(),
        to: this.$helpers.getMomentTZ().month(this.$store.state.rosterFromTo.month).startOf('month').add(1, 'month').format()
      };


      return this.axios({
        method: 'get',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url
      })


    },
    
    loadActiveEmployees(from, to) {
      let params = {
        activeAtFrom: from,
        activeAtTo: to,
        active: true,
      }
      return this.$helpers.GetCall('/api/sec/employee', params).then((response) => {
        return new Promise((resolve, reject) => {
          resolve(response.data);
        })
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });

      });
    },
    loadBannerEmployees(bannerId) {
      let params = {
        bannerId: bannerId
      }
      return this.$helpers.GetCall('/api/sec/banneremployee', params).then((response) => {
        return new Promise((resolve, reject) => {
          resolve(response.data);
        })
      }).catch((e) => {
        return new Promise((resolve, reject) => {
          reject(e);
        });

      });
    },
    ShowStoreBannerConfirmations(storeBannerNotificationT) {
      let view = this;
      let storeBannerNotification = Object.assign({}, storeBannerNotificationT);
      if (storeBannerNotification.confirmable) {
        this.loadBannerEmployees(storeBannerNotification.id).then(result => {
          let selectedEmployees = result.map(i => i.employeeId);
          view.loadActiveEmployees(storeBannerNotification.from, storeBannerNotification.to).then(employees => {
            VueEventBus.$emit("toggle-bannerconfirmation", true, storeBannerNotification, employees, selectedEmployees)
          }).catch(e => {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
          })
        }).catch(e => {
          view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
        })
        

      }
    },
    OpenDateSelection($event) {
      let view = this;
      this.$helpers.OpenDatepickerPopup(
          {viewsEnabled: ['M'], date: this.dateSelectionStart.clone()},
          {
            OnDateSelect: (date) => {
              view.setDateSelection(date, true)
            },
          },
          {elRelative: $event ? $event.currentTarget : null});
    },
    
    setDateSelection(date, calculateRosterFromTo) {
      let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
      this.dateSelectionStart = fixedDate;

      if (calculateRosterFromTo) {
        //update vuex store with calculated from to => triggers reload of data via refresh
        let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
        this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
      } else {
        //dont update vuex from to, only update client side view
      }
    },
    NewStoreBannerNotificationPopup() {
      let view = this;
      this.PopupNewBannerNotification({currentTarget: null}, this.$helpers.getMomentTZ().startOf('day'), (storeBannerNotification) => {
        storeBannerNotification.state = storeBannerNotification.state === true ? 1 : 2;
        if (storeBannerNotification.noFrom || storeBannerNotification.noTo || storeBannerNotification.from < storeBannerNotification.to) {
          if (storeBannerNotification.noFrom) {
            storeBannerNotification.from = null;
          }
          if (storeBannerNotification.noTo) {
            storeBannerNotification.to = null;
          }
          if(storeBannerNotification.selectedEmployeesOnly){
            view.NewStoreBannerNotificationForSelectedEmployees(storeBannerNotification);
          } else {
            view.NewStoreBannerNotification(storeBannerNotification);
          }
          
        } else {
          view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('pages.comp.invalidBannerDate'));
        }

      });
    },
    PopupNewBannerNotification($event, date, createCallback) {

      let view = this;
      let spotItems = Object.values(this.spotMap).map(i => {return {label: i.name, value: i.id, data: i}});
      spotItems.sort((a,b) => {
          return  (a.label > b.label)? 1 : (b.label > a.label)? -1 : 0;
      });
      spotItems.push({label: this.$t('pages.comp.allPositions'), value: null});
      let selectedSpot = {label: this.$t('pages.comp.allPositions'), value: null};

      let nationalityItems = Object.values(this.countryMap).map(i => {return {label: i.label_de, value: i.id, data: i}});
      nationalityItems.sort((a,b) => {
          return  (a.label > b.label)? 1 : (b.label > a.label)? -1 : 0;
      });
      nationalityItems.push({label: this.$t('pages.comp.allNationalities'), value: null});
      let selectedNationality= {label: this.$t('pages.comp.allNationalities'), value: null};

      let employeeItems = Object.values(this.employeeMap).filter(e => e.active).map(e => {return {label: e.lastName+ " "+e.firstName, value: e.id, data: e}});
      employeeItems.sort((a,b) => {
          return  (a.label > b.label)? 1 : (b.label > a.label)? -1 : 0;
      });

      let dataEntries = [
        {
          label: this.$t('roster.main.title'),
          key: 'description',
          hidden: false,
          type: 'text',
          value: '',
          length: 50
        },
        {
          label: this.$t('pages.comp.text'),
          key: 'text',
          hidden: false,
          type: 'text',
          value: ''
        },
        {label: this.$t('workBalance.bonus.recursIndefinitely'), key: 'noFrom', hidden: false, disabled: false, type: 'bool', value: true},
        {label: this.$t('workBalance.bonus.validFrom'), key: 'from', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('noFrom'), type: 'datetimeframe', value: date.startOf('day'), flexGroup: false},
        {label: this.$t('workBalance.bonus.recursIndefinitely'), key: 'noTo', hidden: false, disabled: false, type: 'bool', value: true},
        {label: this.$t('pages.employeeContract.validUntil'), key: 'to', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('noTo') , type: 'datetimeframe', value: date.clone().add(1,'days').startOf('day'), flexGroup: false},
        {label: this.$t('pages.comp.onlyCertainEmployees'), key: 'selectedEmployeesOnly', hidden: false, disabled: false, type: 'bool', value: false},
        {label: this.$tc('global.general.employee'), key: 'employees', hidden: this.$helpers.CheckDatafillKeysForHidden('selectedEmployeesOnly'), type: 'dropdownsearch', value: null, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: employeeItems,
                    selectMultiple: true,
                    selectFirst: false,
                    styleLight: true,
                }
        },
        {label: this.$tc('store.structure.employeeLevel'), key: 'employeeLevels', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectedEmployeesOnly'), type: 'dropdownsearch', value: [1, 2], dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: this.employeeLevels.map(c => {
                        return {
                            label: c.label,
                            value: c.value,
                            selected: true
                        }
                    }),
                    selectMultiple: true,
                    selectFirst: false,
                    styleLight: true,
                }
        },
        {label: this.$tc('shift.main.position'), key: 'spotId', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectedEmployeesOnly'), type: 'dropdownsearch', value: null, dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: spotItems,
                selectMultiple: false,
                selectedItem: selectedSpot,
                selectFirst: false,
                styleLight: true,
        }},
        {label: this.$t('pages.employeeContext.nationality'), key: 'nationality', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('selectedEmployeesOnly'), type: 'dropdownsearch', value: null, dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: nationalityItems,
                selectMultiple: false,
                selectedItem: selectedNationality,
                selectFirst: false,
                styleLight: true,
        }},
        {
          label: this.$t('pages.comp.importance'),
          key: 'level',
          hidden: false,
          type: 'dropdownsearch',
          value: 3,
          selectMultiple: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: [
              {
                label: this.$t('pages.comp.veryImportant'),
                value: 1
              },
              {
                label: this.$t('pages.comp.important'),
                value: 2
              },
              {
                label: this.$t('pages.comp.information'),
                value: 3
              },
            ],
            selectMultiple: false,
            selectFirst: false,
            selectedItem: {
                label: this.$t('pages.comp.information'),
                value: 3
              },
            selectedItems: [],
            styleLight: true,
          }
        },
        {
          label: this.$t('pages.comp.showOnStartPage'),
          key: 'state',
          hidden: false,
          type: 'bool',
          value: true
        },
        {
          label: this.$t('pages.comp.mustConfirm'),
          key: 'confirmable',
          hidden: false,
          type: 'bool',
          value: false
        },
        {
          label: this.$t('store.api.active'),
          key: 'active',
          hidden: false,
          type: 'bool',
          value: true
        },
      ];
      let target = $event.currentTarget;

      this.$helpers.OpenPopup({
        elRelative: target,
        type: 'datafill',
        componentState: {
          entries: dataEntries,
           errorCheck: [
              (entries) => {
                  if(entries['description'] == null|| entries['description'].length == 0){
                    return {key: 'description', type: 'error', label: this.$t('roster.main.title'), text: this.$t('pref.main.pleaseEnterTitle')}
                  } else {
                    return null
                  } 
              },
              (entries) => {
                  if(entries['text'] == null|| entries['text'].length == 0){
                    return {key: 'text', type: 'error', label: "Text", text: this.$t('pages.comp.pleaseEnterText')}
                  } else {
                    return null
                  } 
              },
              (entries) => {
                  if(entries['noFrom'] == false && entries['noTo'] == false && entries['from'] != null && entries['to'] != null && entries['from'] >= entries['to']){
                    return {key: 'from', type: 'error', label: this.$t('store.settings.date'), text: this.$t('pref.main.fromBeforeTo')}
                  } else {
                    return null
                  } 
              },
              (entries) => {
                  if(entries['selectedEmployeesOnly'] == false && (entries['employeeLevels'] == null || entries['employeeLevels'].length == 0)){
                    return {key: 'employeeLevels', type: 'error', label: this.$tc('global.general.employee'), text: this.$t('pages.comp.pleaseSelectEmployeeLevelMin')}
                  } else {
                    return null
                  } 
              },
              (entries) => {
                  if(entries['selectedEmployeesOnly'] == true && (entries['employees'] == null || entries['employees'].length == 0)){
                    return {key: 'employees', type: 'error', label: this.$tc('global.general.employee'), text: this.$t('workBalance.extraPay.selectEmployeeMin')}
                  } else {
                    return null
                  } 
              },
          ],
          selectCallback: createCallback
        },
        header: this.$t('global.ui.newX', [this.$t('pages.comp.information')]),
        expanded: true,
        centered: true
      });
    },
    NewStoreBannerNotification(storeBannerNotification) {
      let view = this;
      let url = '/api/sec/bannernotification';

      let params = {
        storeId: this.$store.state.storeId
      };

      let payload = {
        description: storeBannerNotification.description,
        from: storeBannerNotification.from,
        to: storeBannerNotification.to,
        level: storeBannerNotification.level,
        state: storeBannerNotification.state,
        confirmable: storeBannerNotification.confirmable,
        active: storeBannerNotification.active,
        text: storeBannerNotification.text,
        spotId: storeBannerNotification.spotId,
        employeeLevels: storeBannerNotification.employeeLevels,
        nationality: storeBannerNotification.nationality
      };

      this.axios({
        method: 'post',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).then(response => {
        view.$set(view.storeBannerNotificationMap, response.data.data.id, response.data.data);
        view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('global.ui.createdX', [view.$t('pages.comp.appInformation')]))

      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createFailed'));
        console.log(error)
      })

    },
    NewStoreBannerNotificationForSelectedEmployees(storeBannerNotification) {
      let view = this;
      let url = '/api/sec/bannernotification/selectedemployees';

      let params = {
        storeId: this.$store.state.storeId
      };

      let payload = {
        description: storeBannerNotification.description,
        from: storeBannerNotification.from,
        to: storeBannerNotification.to,
        level: storeBannerNotification.level,
        state: storeBannerNotification.state,
        confirmable: storeBannerNotification.confirmable,
        active: storeBannerNotification.active,
        text: storeBannerNotification.text,
        employeeIds: storeBannerNotification.employees,
      };

      this.axios({
        method: 'post',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).then(response => {
        view.$set(view.storeBannerNotificationMap, response.data.data.id, response.data.data);
        view.$helpers.success(view.$t('store.events.creationSuccessful'), view.$t('global.ui.createdX', [view.$t('pages.comp.appInformation')]))

      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createFailed'));
        console.log(error)
      })

    },
    EditStoreBannerNotification(storeBannerNotificationT) {
      let view = this;
      let storeBannerNotification = Object.assign({}, storeBannerNotificationT);
      if(storeBannerNotification.selectedEmployeesOnly) {
         this.loadBannerEmployees(storeBannerNotification.id).then(result => {
            this.PopupEditBannerNotification({currentTarget: null}, storeBannerNotification, (storeBannerNotification) => {
          

              storeBannerNotification.state = storeBannerNotification.state === true ? 1 : 2;
              if (storeBannerNotification.noFrom || storeBannerNotification.noTo || storeBannerNotification.from < storeBannerNotification.to) {
                if (storeBannerNotification.noFrom) {
                  storeBannerNotification.from = null;
                }
                if (storeBannerNotification.noTo) {
                  storeBannerNotification.to = null;
                }
                view.UpdateStoreBannerNotification(storeBannerNotification);
                view.ReplaceBannerEmployees(storeBannerNotification);
              } else {
                view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('pages.comp.invalidDate'));
              }

            }, result);
         }).catch(error => {
            
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('roster.main.loadingEmployeeError'));
         })
      } else {
        this.PopupEditBannerNotification({currentTarget: null}, storeBannerNotification, (storeBannerNotification) => {
          

          storeBannerNotification.state = storeBannerNotification.state === true ? 1 : 2;
          if (storeBannerNotification.noFrom || storeBannerNotification.noTo || storeBannerNotification.from < storeBannerNotification.to) {
            if (storeBannerNotification.noFrom) {
              storeBannerNotification.from = null;
            }
            if (storeBannerNotification.noTo) {
              storeBannerNotification.to = null;
            }
            view.UpdateStoreBannerNotification(storeBannerNotification);
          } else {
            view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('pages.comp.invalidDate'));
          }

        });
      }
      
      
    },
    PopupEditBannerNotification($event, event, editCallback, banneremployees = []) {

      let view = this;
      let spotItems = Object.values(this.spotMap).map(i => {return {label: i.name, value: i.id, data: i}});
      spotItems.sort((a,b) => {
          return  (a.label > b.label)? 1 : (b.label > a.label)? -1 : 0;
      });
      spotItems.push({label: this.$t('pages.comp.allPositions'), value: null});
      let selectedSpot = {label: this.$t('pages.comp.allPositions'), value: null};
      if(event.spotId){
        selectedSpot = spotItems.find(i => i.value == event.spotId);
      }

      let nationalityItems = Object.values(this.countryMap).map(i => {return {label: i.label_de, value: i.id, data: i}});
      nationalityItems.sort((a,b) => {
          return  (a.label > b.label)? 1 : (b.label > a.label)? -1 : 0;
      });
      nationalityItems.push({label: this.$t('pages.comp.allNationalities'), value: null});
      let selectedNationality= {label: this.$t('pages.comp.allNationalities'), value: null};
      if(event.nationality){
        selectedNationality = nationalityItems.find(i => i.value == event.nationality);
      }

      let employeeItems = Object.values(this.employeeMap).filter(e => e.active).map(e => {return {label: e.lastName+ " "+e.firstName, value: e.id, data: e, selected: banneremployees.find(be => be.employeeId == e.id)}});
      employeeItems.sort((a,b) => {
          return  (a.label > b.label)? 1 : (b.label > a.label)? -1 : 0;
      });
      let employeeValues = employeeItems.filter(ei => ei.selected).map(ei => ei.value);

      let dataEntries = [
        {
          label: 'Id',
          key: 'id',
          hidden: true,
          type: 'text',
          value: event.id,
          length: 20
        },
        {
          label: this.$t('roster.main.title'),
          key: 'description',
          hidden: false,
          type: 'text',
          length: 50
        },
        {label: this.$t('workBalance.bonus.recursIndefinitely'), key: 'noFrom', hidden: false, disabled: false, type: 'bool', value: event.from == null},
        {label: this.$t('workBalance.bonus.validFrom'), key: 'from', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('noFrom'), type: 'datetimeframe', value: event.from ? event.from : this.$helpers.getMomentTZ().startOf('day'), flexGroup: false},
        {label: this.$t('workBalance.bonus.recursIndefinitely'), key: 'noTo', hidden: false, disabled: false, type: 'bool', value: event.to == null},
        {label: this.$t('pages.employeeContract.validUntil'), key: 'to', hidden: this.$helpers.CheckDatafillKeysForHiddenInverted('noTo') , type: 'datetimeframe', value: event.to ? event.to : this.$helpers.getMomentTZ().add(1,'days').startOf('day'), flexGroup: false},
        {label: this.$t('pages.comp.onlyCertainEmployees'), key: 'selectedEmployeesOnly', hidden: false, disabled: true, type: 'bool', value: event.selectedEmployeesOnly},
        {label: this.$tc('global.general.employee'), key: 'employees', hidden: !event.selectedEmployeesOnly, type: 'dropdownsearch', value: employeeValues, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: employeeItems,
                    selectMultiple: true,
                    selectFirst: false,
                    styleLight: true,
                }
        },
        {label: this.$tc('global.general.employee'), key: 'employeeLevels', hidden: event.selectedEmployeesOnly, type: 'dropdownsearch', value: event.employeeLevels, dropdownSearchState:{
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: this.employeeLevels.map(c => {
                        return {
                            label: c.label,
                            value: c.value,
                            selected: event.employeeLevels.find(v => v == c.value) != null
                        }
                    }),
                    selectMultiple: true,
                    selectFirst: false,
                    styleLight: true,
                }
        },
        {label: this.$tc('shift.main.position'), key: 'spotId', hidden: event.selectedEmployeesOnly, type: 'dropdownsearch', value: null, dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: spotItems,
                selectMultiple: false,
                selectedItem: selectedSpot,
                selectFirst: false,
                styleLight: true,
        }},
        {label: this.$t('pages.employeeContext.nationality'), key: 'nationality', hidden: event.selectedEmployeesOnly, type: 'dropdownsearch', value: null, dropdownSearchState:{
                toggled: false,
                displayedItems: [],
                input: '',
                items: nationalityItems,
                selectMultiple: false,
                selectedItem: selectedNationality,
                selectFirst: false,
                styleLight: true,
        }},
        {
          label: this.$t('pages.comp.importance'),
          key: 'level',
          hidden: false,
          type: 'dropdownsearch',
          value: event.level,
          selectMultiple: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: [
              {
                label: view.$t('pages.comp.high'),
                value: 1
              },
              {
                label: view.$t('pages.comp.medium'),
                value: 2
              },
              {
                label: view.$t('pages.comp.low'),
                value: 3
              }
            ],
            selectMultiple: false,
            selectFirst: false,
            selectedItems: [],
            styleLight: true,
          }
        },
        {
          label: this.$t('pages.comp.frontpage'),
          key: 'state',
          hidden: false,
          type: 'bool',
          value: event.state === 1
        },
        {
          label: this.$t('pages.comp.confirmable'),
          key: 'confirmable',
          hidden: false,
          type: 'bool',
          value: event.confirmable
        },
        {
          label: this.$t('global.general.active'),
          key: 'active',
          hidden: false,
          type: 'bool',
          value: event.active
        },
        {
          label: 'Text',
          key: 'text',
          hidden: false,
          type: 'text',
          value: event.text
        },
      ];

      if (event) {
        for (let x in event) {
          let entry = dataEntries.find(e => e.key === x);
          if (entry) {
            if (x === 'from' || x === 'to') {
              //do nothing
            } else if (x === 'level') {
              entry.dropdownSearchState.selectedItem = entry.dropdownSearchState.items.find(i => event[x] === i.value);
              if (entry.dropdownSearchState.selectedItem) entry.dropdownSearchState.input = entry.dropdownSearchState.selectedItem.label;
            } else if (x === 'state') {
              entry.value = event[x] === 1;
            } else {
              entry.value = event[x];
            }
          }
        }
      }
      let target = $event.currentTarget;

      this.$helpers.OpenPopup({
        elRelative: target,
        type: 'datafill',
        componentState: {
          entries: dataEntries,
          errorCheck: [
              (entries) => {
                  if(entries['description'] == null|| entries['description'].length == 0){
                    return {key: 'description', type: 'error', label: this.$t('roster.main.title'), text: this.$t('pref.main.pleaseEnterTitle')}
                  } else {
                    return null
                  } 
              },
              (entries) => {
                  if(entries['text'] == null|| entries['text'].length == 0){
                    return {key: 'text', type: 'error', label: "Text", text: this.$t('pages.comp.pleaseEnterText')}
                  } else {
                    return null
                  } 
              },
              (entries) => {
                  if(entries['noFrom'] == false && entries['noTo'] == false && entries['from'] != null && entries['to'] != null && entries['from'] >= entries['to']){
                    return {key: 'from', type: 'error', label: this.$t('store.settings.date'), text: view.$t('pref.main.fromBeforeTo')}
                  } else {
                    return null
                  } 
              },
              (entries) => {
                  if(entries['selectedEmployeesOnly'] == false && (entries['employeeLevels'] == null || entries['employeeLevels'].length == 0)){
                    return {key: 'employeeLevels', type: 'error', label: this.$tc('global.general.employee'), text: this.$t('pages.comp.pleaseSelectEmployeeLevelMin')}
                  } else {
                    return null
                  } 
              },
              (entries) => {
                  if(entries['selectedEmployeesOnly'] == true && (entries['employees'] == null || entries['employees'].length == 0)){
                    return {key: 'employees', type: 'error', label: this.$tc('global.general.employee'), text: this.$t('workBalance.extraPay.selectEmployeeMin')}
                  } else {
                    return null
                  } 
              },
          ],
          selectCallback: editCallback
        },
        header: view.$t('global.ui.editX', [view.$t('pages.comp.information')]),
        expanded: true,
        centered: true
      });
    },
    UpdateStoreBannerNotification: function (storeBannerNotification) {

      let view = this;
      let url = '/api/sec/bannernotification';

      let params = {
        storeId: this.$store.state.storeId
      };

      let payload = {
        id: storeBannerNotification.id,
        description: storeBannerNotification.description,
        from: storeBannerNotification.from ? storeBannerNotification.from.format() : null,
        to: storeBannerNotification.to ? storeBannerNotification.to.format() : null,
        level: storeBannerNotification.level,
        state: storeBannerNotification.state,
        confirmable: storeBannerNotification.confirmable,
        active: storeBannerNotification.active,
        text: storeBannerNotification.text,
        spotId: storeBannerNotification.spotId,
        employeeLevels: storeBannerNotification.employeeLevels,
        selectedEmployeesOnly: storeBannerNotification.selectedEmployeesOnly,
        nationality: storeBannerNotification.nationality,
        updateFields: ["from", "to", "description", "level", "state", "confirmable", "text", "active", "employeeLevels", "spotId", "nationality"]
      };

      this.axios({
        method: 'put',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).then(response => {
        delete payload.updateFields;
        view.$set(view.storeBannerNotificationMap, payload.id, payload);
        view.$helpers.success(view.$t('global.notifications.success'), '');
      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.updateFailed'));
        console.log(error)
      })

    },
    ReplaceBannerEmployees: function (storeBannerNotification) {

      let view = this;
      let url = '/api/sec/banneremployee/replace';

      let params = {
        storeId: this.$store.state.storeId
      };

      let payload = {
        bannerId: storeBannerNotification.id,
        employeeIds: storeBannerNotification.employees,
      };

      this.axios({
        method: 'post',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url,
        data: payload
      }).then(response => {
        view.$helpers.success(view.$t('global.notifications.success'), view.$t('pages.comp.employeeAppInformationEdited'));
      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.updateFailed'));
        console.log(error)
      })

    },
    

    updateStoreBannerNotifications: function (data) {
      let tbannernotifications = [];
      let tMap = {};
      for (let i = 0; i < data.length; i++) {
        tbannernotifications.push(data[i]);
        tMap[data[i].id] = data[i];

      }

      this.storebannernotifications = tbannernotifications;
      this.storeBannerNotificationMap = tMap;
    },
    DeleteBannerNotificationPopup(storeBannerNotification) {

      let view = this;
      window.app.popupalerts.push({
        header: this.$t('global.ui.deleteX', [this.$t('pages.comp.information')]),
        description: this.$t('pages.comp.appInformation') + ': ' + storeBannerNotification.description + '. ' + this.$t('global.ui.deleteQuery'),
        callbackAccept: function (popup) {
          //popup.loading = true;
          view.DeleteStoreBannerNotification(storeBannerNotification);
          popup.hidden = true;
        },
        callbackCancel: function (popup) {
          popup.loading = false;
          popup.hidden = true;
        }
      });
    },
    
    DeleteStoreBannerNotification(storeBannerNotification) {
      let view = this;
      let url = '/api/sec/bannernotification';

      let params = {
        id: storeBannerNotification.id,
        storeId: this.$store.state.storeId
      }


      this.axios({
        method: 'delete',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url
      }).then(response => {

        view.$delete(view.storeBannerNotificationMap, storeBannerNotification.id);

      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deleteFailed'));
        console.log(error)
      })
    },
    
    
  },

}
</script>

<style scoped>
.scrollbar-container {
  padding: 20px;
}
</style>
